import { useMemo } from 'react';

import { useJobContext } from 'pages/Job/context';

export interface OpenBankingHook {
  companyName: string;
  companyEmail: string | undefined;
  companyPhone: string | undefined;
  overlayLabel: string;
  showDetails: boolean;
}

export default function useOpenBanking(): OpenBankingHook {
  const { jobCompanyInfo, isLoading } = useJobContext();

  const companyName = useMemo(() => {
    if (isLoading) return 'Your tradesperson';
    return jobCompanyInfo?.company_name ?? 'Your tradesperson';
  }, [isLoading, jobCompanyInfo]);

  const companyEmail = useMemo(() => {
    if (isLoading) return undefined;
    return jobCompanyInfo?.contact_info?.contact_email;
  }, [isLoading, jobCompanyInfo]);

  const companyPhone = useMemo(() => {
    if (isLoading) return undefined;
    return jobCompanyInfo?.contact_info?.contact_phone;
  }, [isLoading, jobCompanyInfo]);

  const showDetails = useMemo(
    () => Boolean(companyPhone) || Boolean(companyEmail),
    [companyEmail, companyPhone],
  );

  const overlayLabel = useMemo(
    () =>
      [
        `You can reach out to ${companyName} using`,
        showDetails
          ? 'the contact details provided below. Alternatively, feel free to get in touch using'
          : '',
        'any contact method or channels from your previous correspondence with them.',
      ].join(' '),
    [companyName, showDetails],
  );

  return {
    companyName,
    companyEmail,
    companyPhone,
    overlayLabel,
    showDetails,
  };
}
